<template>
  <el-dialog
    width="40%"
    class="dialog"
    title="旧机补贴发放审核驳回"
    :visible.sync="dialogFormVisible"
    :appendToBody="true"
  >
    <el-form
      ref="ruleForm"
      label-position="right"
      :rules="rules"
      :model="formData"
      label-width="120px"
    >
      <el-form-item  prop="failReason" label="驳回原因" class="read-only"
        >
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4}"
          placeholder="请输入内容"
          maxlength="150"
          v-model="formData.failReason">
        </el-input>
        </el-form-item
      >
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" :loading="btnLoading" @click="submitBtnFun"
        >驳回审核</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      dialogFormVisible: false,
      //订单 id
      orderNo: "",
      // 表单数据
      formData: {
        pass:0,
        failReason:''
      },
      rules: {
        failReason: [
          { required: true, message: "请输入驳回原因", trigger: "blur" }
        ],

      },
      btnLoading: false
    };
  },
  computed: {
  },
  watch: {},
  methods: {
    // 关闭弹框
    closeDialog() {
      this.dialogFormVisible = false;
    },
    // 打开弹框
    async openDialog(id) {
      this.orderNo = id
      this.dialogFormVisible = true;
    },
    // 确认驳回审核
    submitBtnFun() {
      this.$refs.ruleForm.validate(valid => {
				if (valid) {


      let params = {};
      params.subsidyNos = [this.orderNo];
      params.pass=this.formData.pass
      params.failReason=this.formData.failReason

      // this.listLoading = true;
      this.HttpService.post(
        "/autoapp-default-server-recovery/api/oldMachineSubsidy/verifyOldMachineSubsidy",
        params
      ).then(res => {
        if (res.statusCode == 200) {
        this.$message.success("驳回审核成功");
        this.dialogFormVisible = false;
        this.$emit('verifySuccess')
      } else {
        this.$message.error(message);
      }
      });
    }
  })
    }
  }
};
</script>
<style scoped lang="scss">
.dialog {
  padding: 0 20px;
  .el-dialog__body {
    padding-top: 10px;
  }
  .dialog-footer {
    padding: 20px;
    padding-top: 0;
  }
  .el-form-item--small.el-form-item {
    &.read-only {
      margin-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/oldMachineSubsidy/components/rejectDialog.vue